import { render, staticRenderFns } from "./NavInvoice.vue?vue&type=template&id=74f71ffb&scoped=true"
import script from "./NavInvoice.vue?vue&type=script&lang=js"
export * from "./NavInvoice.vue?vue&type=script&lang=js"
import style0 from "./NavInvoice.vue?vue&type=style&index=0&id=74f71ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f71ffb",
  null
  
)

export default component.exports